import React from 'react';
import { InputAdornment, TextField } from '@mui/material';

import { COLORS } from '../Constant/COLORS';
import { TypoPoppins } from './Typo';

const PhoneNumberField = props => {
  return (
    <TextField
      inputProps={{ spellCheck: false }}
      inputMode='tel'
      autoComplete='tel'
      InputProps={{
        startAdornment: (
          <InputAdornment position='start' sx={{ borderRadius: 'inherit' }}>
            <TypoPoppins
              bgcolor={COLORS.grey5}
              py={1.2}
              px={1.5}
              borderRadius='inherit'
              fontWeight={600}
              sx={{ borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
            >
              +94
            </TypoPoppins>
          </InputAdornment>
        ),
        style: { padding: 0 },
      }}
      {...props}
    />
  );
};

export default PhoneNumberField;
